<template>
  <div>
    <h3>Final Step!</h3>
    <small>The final step to activating your account is to save your card on file.</small>
      <hr/>
    <button class="col m-2 card-1 btn btn-outline-primary w-50" @click="subscribe">Proceed</button>
  </div>
</template>

<script>
import { db, auth } from '../../firebase'


export default {
  name: "Card-Info",
  data: () => ({

    // price: 'price_1HtwuzJjgmqFW6V3MPObCoFn', // monthly thing
    price: "price_1HwaWIJjgmqFW6V385YHtJSI", // free one-time
    success_url: `${window.location.origin}/stripe?processed=true`,
    cancel_url: `${window.location.origin}/stripe?processed=false`,

    test_api_key: 'pk_test_S8ZVtTgHKCVlDN62P4IGNo8k00exGez5HV',
    live_api_key: 'pk_live_AUway8mZu27mARjLvwkTLyAt00BdBBReLe',

    publishableKey: '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',
    // items: [
    //   {
    //     sku: 'price_1HtwuzJjgmqFW6V3MPObCoFn', 
    //     quantity: 1
    //   }
    // ],

  }),

  methods: {
    async subscribe() {
      const docRef = await db
        .collection('customers')
        .doc(auth.currentUser.uid)
        .collection('checkout_sessions')
        .add({
          price: this.price,
          success_url: this.success_url,
          cancel_url: this.cancel_url,
        });
      // Wait for the CheckoutSession to get attached by the extension
      docRef.onSnapshot((snap) => {
        const { error, sessionId } = snap.data();
        if (error) {
          // Show an error to your customer and 
          // inspect your Cloud Function logs in the Firebase console.
          alert(`An error occured: ${error.message}`);
        }
        if (sessionId) {
          // We have a session, let's redirect to Checkout
          // Init Stripe
          
          console.log(this.live_api_key)
          const stripe = Stripe( this.live_api_key );
          console.log(stripe)
          stripe.redirectToCheckout({ sessionId });
        }
      });
    }
  }
}
</script>